import { useFlag } from '@simplywallst/unleash';

export const withFlag = (Component: React.FC) => {
  return () => {
    const giftCardFlag = useFlag('mono-gift-card-feature');
    const giftCardFeatureEnabled = giftCardFlag?.ready && giftCardFlag?.enabled;

    return giftCardFeatureEnabled ? <Component /> : null;
  };
};
